import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TitleAnnouncerComponent } from './title-announcer.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        TitleAnnouncerComponent
    ],
    exports: [
        TitleAnnouncerComponent
    ]
})
export class TitleAnnouncerModule {
}
